import { useMutation, useQueryClient } from "@tanstack/react-query";

import { renameOrganization } from "./api";
import type { OrganizationResponse, RenameOrganizationRequest } from "./api";

// PATCH имени организации. Имя читается из списка организаций
// пользователя (`/me/organizations`), поэтому на успех инвалидируем его.
export function useRenameOrganization(): ReturnType<
  typeof useMutation<OrganizationResponse, Error, RenameOrganizationRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<OrganizationResponse, Error, RenameOrganizationRequest>({
    mutationFn: (body) => renameOrganization(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["available-organizations"],
      });
    },
  });
}
